import { Expose, Type } from "class-transformer";
import { Model } from "./model";
import { SessionsRecordModel } from "./sessions-record-model";

export class Session extends Model {
    @Expose() id : string ;
    @Expose() assignmentValue : number;
    @Expose() call : string;
    @Expose() rate : number;
    @Expose() 
    @Type(()=>SessionsRecordModel)
    records : SessionsRecordModel[];
    
}